import { useRelations } from '@hooks/useRelatedEntity'

import type { RelatedEntityModel } from '@models/types'

import RelatedEntityListItem from '@components/RelatedEntityListItem'

interface RelatedEntityProps {
  callbacks: {
    deleteRelatedEntity: () => void,
  },
  relatedEntity: RelatedEntityModel,
}

const RelatedEntity = (props: RelatedEntityProps) => {
  const {
    callbacks: { deleteRelatedEntity },
    relatedEntity,
  } = props

  const { subject } = useRelations(relatedEntity)

  return (
    <RelatedEntityListItem
      callbacks={{ deleteRelatedEntity }}
      key={relatedEntity.id}
      relatedEntity={relatedEntity}
      subject={subject}
    />
  )
}

export default RelatedEntity
